import "./drop-area.scss";

export default class {
  dontClose = false;

  constructor() {
    this.dropArea = $(".js-drop-area");
    this.parent = $(document.body);
    this.parent.on("dragenter.droparea", e => {
      this.onDragEnter(e);
    });
  }

  onDragEnter(e) {
    if (this.inDropArea(e)) {
      this.dontClose = true;
      return;
    }
    this.showDropArea();
    this.parent.off("dragleave.custom");
    this.parent.on("dragleave.custom", _e => {
      this.onDragLeave(_e);
    });
    $(".close-modal", this.dropArea).on("click", () => {
      this.dropArea.hide();
    });
  }

  onDragLeave() {
    if (this.dontClose) {
      this.dontClose = false;
    } else {
      this.hideDropArea();
    }
  }

  showDropArea() {
    this.dropArea.show();
  }

  hideDropArea() {
    this.dropArea.hide();
  }

  inDropArea(e) {
    return e.target === this.dropArea[0] || $(e.target).parents(".js-drop-area").length === 1;
  }
}
